import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  homeProducts: [],
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setHomeProducts: (state, action) => {
      state.homeProducts = action.payload;
    },
    clearHomeProducts: (state) => {
      state.homeProducts = [];
    },
  },
});

export const { setHomeProducts, clearHomeProducts } = productsSlice.actions;
export default productsSlice.reducer;
